import { APP_SCORING_FORMAT } from '@/constants';
import { formatScore } from '@/domains';
import { cn } from '@/utils';
import { FailSvg, PassSvg, ViolationSvg } from '@/components/Icons';
import { ScorecardProps } from '../types';
import { scorecardStyles } from '../Scorecard.styles';
import { TagSkeleton } from './ScorecardTagSkeleton';
import React from 'react';

type TStatusVariant = 'violation' | 'pass' | 'fail';

export interface VariantStatusProps {
  className?: string;
  isLoading?: boolean;
  score?: number;
  size: NonNullable<ScorecardProps['size']>;
  variant: TStatusVariant;
}

export const VariantStatus: React.FC<VariantStatusProps> = ({
  className,
  isLoading = false,
  score = 0,
  size,
  variant,
}) => {
  if (isLoading) return <TagSkeleton />;

  return (
    <div className={cn(scorecardStyles({ size, variant }), className)}>
      {variant === 'violation' && (
        <div className="flex items-center justify-center">
          <ViolationSvg />
        </div>
      )}

      {(variant === 'pass' || variant === 'fail') && (
        <>
          {APP_SCORING_FORMAT === 'percentage' ? (
            <div
              className={cn('text-xl font-bold', {
                'text-accent-green-500': variant === 'pass',
                'text-accent-border-yellow': variant === 'fail',
              })}
            >
              {formatScore(score, undefined, 'percentage')}
            </div>
          ) : (
            <>
              {variant === 'pass' && <PassSvg />}
              {variant === 'fail' && <FailSvg />}
            </>
          )}
          <div
            className={cn('text-sm font-bold', {
              'text-accent-green-500': variant === 'pass',
              'text-accent-border-yellow': variant === 'fail',
            })}
          >
            {APP_SCORING_FORMAT === 'percentage' ? (
              'Score'
            ) : (
              variant === 'pass' ? 'Pass' : 'Fail'
            )}
          </div>
        </>
      )}
    </div>
  );
};

VariantStatus.displayName = 'VariantStatus';

export default VariantStatus;
